import React, { Component } from 'react'

import { Box } from '@mui/material'
import { bugsnagMetaData, exporter } from 'decorators'
import { connect } from 'react-redux'

import { fetchData } from '@albacross/frontend-utils'

import { fetchCurrentUser } from 'actions/app-actions'

import CoreLayoutDrawer from './CoreLayoutDrawer'
import CoreLayoutHeader from './CoreLayoutHeader'
import CoreLayoutNotifications from './CoreLayoutNotifications'
import { styles } from './coreLayoutStyles'

type CoreLayoutProps = {
  auth?: boolean
  fetchCurrentUser: (...args: any[]) => any
  drawer?: boolean
  main?: React.ElementType
}

type CoreLayoutState = {
  open: boolean
}

class CoreLayout extends Component<CoreLayoutProps, CoreLayoutState> {
  static defaultProps = {
    drawer: false,
    main: () => null,
  }

  state: CoreLayoutState = {
    open: false,
  }

  handleDrawerOpen = () => this.setState({ open: true })

  handleDrawerClose = () => this.setState({ open: false })

  render() {
    const { auth, drawer, main, fetchCurrentUser, ...rest } = this.props
    const { open } = this.state

    const props = { ...rest }

    return (
      <Box sx={(theme: any) => styles(theme).root}>
        <CoreLayoutHeader drawer={drawer} onDrawerOpen={this.handleDrawerOpen} open={open} />

        {drawer && <CoreLayoutDrawer onDrawerClose={this.handleDrawerClose} open={open} />}

        <CoreLayoutNotifications />

        <Box
          component="main"
          sx={(theme: any) => ({ ...styles(theme).content, ...(!open ? styles(theme).contentClose : {}) })}>
          <Box sx={(theme: any) => styles(theme).toolbar} />
          {React.createElement(main as React.ElementType, props)}
        </Box>
      </Box>
    )
  }
}

export default connect(null, { fetchCurrentUser })(
  exporter(
    // Login and 2FA routes (auth: false) must not load user data: a pre-2FA session gets 403 and bounces to /login.
    fetchData(async ({ auth, fetchCurrentUser }: CoreLayoutProps) =>
      auth ? fetchCurrentUser(undefined, undefined, '/login') : undefined,
    )(bugsnagMetaData(CoreLayout)),
  ),
)
